/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UtxInstructionApiSearchParams,
  InstructionQuoteRequest,
  InstructionSubmitRequest,
  InstructionCancelRequest
} from './schema'



export const utxInstructionApiSearch = (
    params: UtxInstructionApiSearchParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/instructions/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxInstructionApiSearchQueryKey = (params: UtxInstructionApiSearchParams,) => [`/instructions/search`, ...(params ? [params]: [])];

    
export type UtxInstructionApiSearchQueryResult = NonNullable<Awaited<ReturnType<typeof utxInstructionApiSearch>>>
export type UtxInstructionApiSearchQueryError = AxiosError<unknown>

export const useUtxInstructionApiSearch = <TData = Awaited<ReturnType<typeof utxInstructionApiSearch>>, TError = AxiosError<unknown>>(
 params: UtxInstructionApiSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxInstructionApiSearch>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxInstructionApiSearchQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxInstructionApiSearch>>> = ({ signal }) => utxInstructionApiSearch(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxInstructionApiSearch>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxInstructionApiPostInstructionQuoteRequest = (
    instructionQuoteRequest: InstructionQuoteRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/instructions/quote`,
      instructionQuoteRequest,options
    );
  }



    export type UtxInstructionApiPostInstructionQuoteRequestMutationResult = NonNullable<Awaited<ReturnType<typeof utxInstructionApiPostInstructionQuoteRequest>>>
    export type UtxInstructionApiPostInstructionQuoteRequestMutationBody = InstructionQuoteRequest
    export type UtxInstructionApiPostInstructionQuoteRequestMutationError = AxiosError<unknown>

    export const useUtxInstructionApiPostInstructionQuoteRequest = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxInstructionApiPostInstructionQuoteRequest>>, TError,{data: InstructionQuoteRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxInstructionApiPostInstructionQuoteRequest>>, {data: InstructionQuoteRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxInstructionApiPostInstructionQuoteRequest(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxInstructionApiPostInstructionQuoteRequest>>, TError, {data: InstructionQuoteRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxInstructionApiPostInstructionSubmit = (
    instructionSubmitRequest: InstructionSubmitRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/instructions/submit`,
      instructionSubmitRequest,options
    );
  }



    export type UtxInstructionApiPostInstructionSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof utxInstructionApiPostInstructionSubmit>>>
    export type UtxInstructionApiPostInstructionSubmitMutationBody = InstructionSubmitRequest
    export type UtxInstructionApiPostInstructionSubmitMutationError = AxiosError<unknown>

    export const useUtxInstructionApiPostInstructionSubmit = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxInstructionApiPostInstructionSubmit>>, TError,{data: InstructionSubmitRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxInstructionApiPostInstructionSubmit>>, {data: InstructionSubmitRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxInstructionApiPostInstructionSubmit(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxInstructionApiPostInstructionSubmit>>, TError, {data: InstructionSubmitRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxInstructionApiCancelInstruction = (
    instructionCancelRequest: InstructionCancelRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/instructions/cancel`,
      instructionCancelRequest,options
    );
  }



    export type UtxInstructionApiCancelInstructionMutationResult = NonNullable<Awaited<ReturnType<typeof utxInstructionApiCancelInstruction>>>
    export type UtxInstructionApiCancelInstructionMutationBody = InstructionCancelRequest
    export type UtxInstructionApiCancelInstructionMutationError = AxiosError<unknown>

    export const useUtxInstructionApiCancelInstruction = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxInstructionApiCancelInstruction>>, TError,{data: InstructionCancelRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxInstructionApiCancelInstruction>>, {data: InstructionCancelRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxInstructionApiCancelInstruction(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxInstructionApiCancelInstruction>>, TError, {data: InstructionCancelRequest}, TContext>(mutationFn, mutationOptions)
    }
    